export default {
  title: 'Welkom in The Louisiana',
  subTitle: 'Je zit aan',
  table: 'Tafel',
  or: 'OF',
};
